export const routes = [
  {
    path: '/',
    name: 'IndexScenePage',
    component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "stage",
      "stageTransition": null,
      "name": "bubble-wave-out"
    }
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/call-logs',
    name: '/call-logs',
    component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/call-logs.vue'),
    /* no children */
    meta: {
      "layout": "settings"
    }
  },
  {
    path: '/notification',
    name: '/notification',
    component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/notification.vue'),
    /* no children */
    meta: {
      "layout": "settings",
      "stageTransition": null,
      "name": "none"
    }
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/index.vue'),
        /* no children */
        meta: {
          "layout": "settings",
          "stageTransition": null,
          "name": "none"
        }
      },
      {
        path: 'card',
        /* internal name: '/settings/card' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/card/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'components',
            /* internal name: '/settings/card/components' */
            /* no component */
            children: [
              {
                path: 'CardCreate',
                name: '/settings/card/components/CardCreate',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/components/CardCreate.vue'),
                /* no children */
              },
              {
                path: 'CardCreationDialog',
                name: '/settings/card/components/CardCreationDialog',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/components/CardCreationDialog.vue'),
                /* no children */
              },
              {
                path: 'CardDetailDialog',
                name: '/settings/card/components/CardDetailDialog',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/components/CardDetailDialog.vue'),
                /* no children */
              },
              {
                path: 'CardListItem',
                name: '/settings/card/components/CardListItem',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/components/CardListItem.vue'),
                /* no children */
              },
              {
                path: 'DeleteCardDialog',
                name: '/settings/card/components/DeleteCardDialog',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/card/components/DeleteCardDialog.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'devices',
        /* internal name: '/settings/devices' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/devices/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/devices/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": {
                "name": "none"
              }
            }
          }
        ],
      },
      {
        path: 'models',
        /* internal name: '/settings/models' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/models/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/models/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none",
              "pageSpecificAvailable": true
            }
          }
        ],
      },
      {
        path: 'modules',
        /* internal name: '/settings/modules' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/modules/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/modules/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'baidu-sync',
            name: '/settings/modules/baidu-sync',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/modules/baidu-sync.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'mcp',
            /* internal name: '/settings/modules/mcp' */
            /* no component */
            children: [
              {
                path: '',
                name: '/settings/modules/mcp/',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/modules/mcp/index.vue'),
                /* no children */
                meta: {
                  "layout": "settings",
                  "stageTransition": {
                    "name": "none"
                  }
                }
              }
            ],
          },
          {
            path: 'memory-long-term',
            name: '/settings/modules/memory-long-term',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/modules/memory-long-term.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'memory-short-term',
            name: '/settings/modules/memory-short-term',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/modules/memory-short-term.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          }
        ],
      },
      {
        path: 'proactive-messaging',
        /* internal name: '/settings/proactive-messaging' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/proactive-messaging/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/proactive-messaging/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          }
        ],
      },
      {
        path: 'providers',
        /* internal name: '/settings/providers' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/providers/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none",
              "pageSpecificAvailable": true
            }
          },
          {
            path: ':id',
            name: '/settings/providers/[id]',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/[id].vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'elevenlabs',
            name: '/settings/providers/elevenlabs',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/elevenlabs.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'fish-audio',
            name: '/settings/providers/fish-audio',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/fish-audio.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'minimax-speech',
            name: '/settings/providers/minimax-speech',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/minimax-speech.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'minimax-speech-cn',
            name: '/settings/providers/minimax-speech-cn',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/minimax-speech-cn.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'neko-teaparty',
            name: '/settings/providers/neko-teaparty',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/neko-teaparty.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'openai-compatible',
            name: '/settings/providers/openai-compatible',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/providers/openai-compatible.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          }
        ],
      },
      {
        path: 'stickers',
        /* internal name: '/settings/stickers' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/stickers/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/stickers/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": {
                "name": "none"
              }
            }
          }
        ],
      },
      {
        path: 'system',
        /* internal name: '/settings/system' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/system/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/system/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none",
              "pageSpecificAvailable": true
            }
          },
          {
            path: 'color-scheme',
            name: '/settings/system/color-scheme',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/system/color-scheme.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'general',
            name: '/settings/system/general',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/system/general.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          }
        ],
      },
      {
        path: 'worldbook',
        /* internal name: '/settings/worldbook' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/worldbook/',
            component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/worldbook/index.vue'),
            /* no children */
            meta: {
              "layout": "settings",
              "stageTransition": null,
              "name": "none"
            }
          },
          {
            path: 'components',
            /* internal name: '/settings/worldbook/components' */
            /* no component */
            children: [
              {
                path: 'CreateWorldBookCard',
                name: '/settings/worldbook/components/CreateWorldBookCard',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/worldbook/components/CreateWorldBookCard.vue'),
                /* no children */
              },
              {
                path: 'DeleteWorldBookDialog',
                name: '/settings/worldbook/components/DeleteWorldBookDialog',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/worldbook/components/DeleteWorldBookDialog.vue'),
                /* no children */
              },
              {
                path: 'WorldBookCard',
                name: '/settings/worldbook/components/WorldBookCard',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/worldbook/components/WorldBookCard.vue'),
                /* no children */
              },
              {
                path: 'WorldBookEditorDialog',
                name: '/settings/worldbook/components/WorldBookEditorDialog',
                component: () => import('/home/runner/work/MeowChat/MeowChat/packages/stage-pages/src/pages/settings/worldbook/components/WorldBookEditorDialog.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/stellar-journey',
    /* internal name: '/stellar-journey' */
    /* no component */
    children: [
      {
        path: '',
        name: '/stellar-journey/',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/stellar-journey/index.vue'),
        /* no children */
        meta: {
          "layout": "plain",
          "stageTransition": {
            "name": "none"
          }
        }
      },
      {
        path: 'collection',
        /* internal name: '/stellar-journey/collection' */
        /* no component */
        children: [
          {
            path: ':type',
            name: '/stellar-journey/collection/[type]',
            component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/stellar-journey/collection/[type].vue'),
            /* no children */
            meta: {
              "layout": "plain",
              "stageTransition": {
                "name": "none"
              }
            }
          }
        ],
      },
      {
        path: 'diary-book',
        name: '/stellar-journey/diary-book',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/stellar-journey/diary-book.vue'),
        /* no children */
        meta: {
          "layout": "plain",
          "stageTransition": {
            "name": "none"
          }
        }
      },
      {
        path: 'gacha',
        name: '/stellar-journey/gacha',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/stellar-journey/gacha.vue'),
        /* no children */
        meta: {
          "layout": "plain",
          "stageTransition": {
            "name": "none"
          }
        }
      },
      {
        path: 'photo-wall',
        name: '/stellar-journey/photo-wall',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/stellar-journey/photo-wall.vue'),
        /* no children */
        meta: {
          "layout": "plain",
          "stageTransition": {
            "name": "none"
          }
        }
      }
    ],
  },
  {
    path: '/system',
    /* internal name: '/system' */
    /* no component */
    children: [
      {
        path: '',
        name: '/system/',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/system/index.vue'),
        /* no children */
        meta: {
          "layout": "settings",
          "stageTransition": null,
          "name": "slide",
          "pageSpecificAvailable": true
        }
      },
      {
        path: 'background-activity',
        name: '/system/background-activity',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/system/background-activity.vue'),
        /* no children */
        meta: {
          "layout": "settings",
          "stageTransition": null,
          "name": "slide"
        }
      },
      {
        path: 'developer',
        name: '/system/developer',
        component: () => import('/home/runner/work/MeowChat/MeowChat/apps/stage-web/src/pages/system/developer.vue'),
        /* no children */
        meta: {
          "layout": "settings",
          "stageTransition": null,
          "name": "slide"
        }
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

